import axios from 'axios';
import { api, headers } from '../../app/conf';

export const postWhatsAppNumbersServices = (token, data) => 
    axios({
        method: 'post',
        url: `${api}/v1/whatsApp`,
        headers: {
            ...headers,
            'X-Access-Token': token,
        },
        data: {
            ...data
        }
    });

export const putWhatsAppNumbersServices = (token, data) => 
    axios({
        method: 'put',
        url: `${api}/v1/whatsApp/${data.botId}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
        },
        data: {
            ...data
        }
    });

// export const getWhatsAppNumbersServices = (token, filters) => 
//     axios({
//         method: 'get',
//         url: `${api}/v1/whatsApp`,
//         headers: {
//             ...headers,
//             'X-Access-Token': token,
//         },
//     });

export const getWhatsAppNumbersServices = (token, filters) => { 
    return {
        data : {
            whatsAppNumber: {

            }
        }
    };
};

export const deleteWhatsAppNumbersServices = (token, data) => 
    axios({
        method: 'delete',
        url: `${api}/v1/whatsApp/${data.botId}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
        },
    });
